interface TrendChartProps {
  title: string;
  points: Array<{ label: string; value: number }>;
  color: string;
  formatValue: (value: number) => string;
}

const MIN_WIDTH = 600;
const MIN_SLOT = 26;
const HEIGHT = 200;
const PADDING_TOP = 26;
const PADDING_BOTTOM = 26;
const PADDING_X = 8;

export function TrendChart({ title, points, color, formatValue }: TrendChartProps) {
  const chartHeight = HEIGHT - PADDING_TOP - PADDING_BOTTOM;
  const width = Math.max(MIN_WIDTH, points.length * MIN_SLOT);
  const barAreaWidth = width - PADDING_X * 2;
  const barSlot = points.length > 0 ? barAreaWidth / points.length : barAreaWidth;
  const barWidth = Math.min(40, barSlot * 0.6);
  const maxValue = Math.max(1, ...points.map((p) => p.value));

  // 本数が多いときは値ラベル・日付ラベルが重なるため、間引いて表示する
  // （正確な値はrect上のtitle要素でホバーすれば確認できる）。
  const showValueLabel = barSlot >= 40;
  const dateLabelStep = barSlot >= 30 ? 1 : Math.ceil(30 / barSlot);

  return (
    <div className="card">
      <h3>{title}</h3>
      {points.length === 0 ? (
        <div style={{ color: "var(--color-text-muted)" }}>データがありません</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <svg viewBox={`0 0 ${width} ${HEIGHT}`} style={{ width: `${width}px`, height: "auto" }}>
            {points.map((point, i) => {
              const barHeight = (point.value / maxValue) * chartHeight;
              const x = PADDING_X + i * barSlot + (barSlot - barWidth) / 2;
              const y = PADDING_TOP + (chartHeight - barHeight);
              return (
                <g key={`${point.label}-${i}`}>
                  <title>
                    {point.label}: {formatValue(point.value)}
                  </title>
                  {showValueLabel && (
                    <text x={x + barWidth / 2} y={y - 6} textAnchor="middle" fontSize="11" fill="var(--color-text)">
                      {formatValue(point.value)}
                    </text>
                  )}
                  <rect x={x} y={y} width={barWidth} height={Math.max(0, barHeight)} rx={3} fill={color} />
                  {i % dateLabelStep === 0 && (
                    <text
                      x={x + barWidth / 2}
                      y={HEIGHT - PADDING_BOTTOM + 16}
                      textAnchor="middle"
                      fontSize="11"
                      fill="var(--color-text-muted)"
                    >
                      {point.label}
                    </text>
                  )}
                </g>
              );
            })}
          </svg>
        </div>
      )}
    </div>
  );
}
